import { render, staticRenderFns } from "./SubAdmin.vue?vue&type=template&id=699e3034&"
import script from "./SubAdmin.vue?vue&type=script&lang=js&"
export * from "./SubAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports